import { AnimatePresence } from "motion/react";
import { Fragment } from "react";
import { RouterProvider } from "react-router-dom";
import SentryBoundary from "sentry";

import { Toaster } from "@krea/shared/design-system/Toaster";
import { TWStylesWrapper } from "@krea/shared/design-system/TWStylesWrapper";

import { useGetMeQuery } from "@/features/users/hooks/use-get-me.query";

import { Modal } from "../components/modals";
import { router } from "./router";

const AppRoutes = () => {
  return (
    <Fragment>
      <AnimatePresence initial={false} mode="wait" />
      <RouterProvider router={router} />
      <Modal />
    </Fragment>
  );
};

const App = () => {
  const { data: lenderInfo } = useGetMeQuery();

  return (
    <TWStylesWrapper>
      <SentryBoundary lenderInfo={lenderInfo}>
        <AppRoutes />
        <Toaster />
      </SentryBoundary>
    </TWStylesWrapper>
  );
};

// eslint-disable-next-line import/no-default-export
export default App;
